import { IEnumContractStatus } from '@bcc-life/sandbox';

export const ruTranslations = {
  translation: {
    additionalAgreement: {
      activeSince: 'Действует с',
      activityChanged: 'Изменился вид деятельности — пересчитаны класс риска и тариф',
      addBranch: 'Добавить филиал',
      agreementNumber: 'Номер соглашения',
      banner: {
        rejectedTitle: 'Заявка {{number}} отклонена менеджером',
        text: 'По вопросам доп. соглашения обратитесь к менеджеру',
        title: 'Внимание! По данному договору уже создана заявка на доп соглашение',
      },
      binNotFound: 'Организация по данному БИН не найдена',
      branch: 'Филиал',
      cancel: 'Отменить',
      cancelConfirm: 'Введённые данные не сохранятся. Отменить оформление допсоглашения?',
      cancelTitle: 'Отменить оформление',
      changed: 'Данные изменились',
      continueDraft: 'Продолжить оформление',
      contractNumber: '№ договора',
      corrected: 'Скорректированные данные',
      create: 'Создать',
      createAgreement: 'Создать доп. соглашение',
      documentBase: 'Документ основание',
      documentDate: 'Дата документа',
      documentNumber: 'Номер документа',
      documentRequired: 'Заполните документ-основание: вид, номер и дату',
      draftModal: {
        text: 'По этому договору есть незаконченная заявка на допсоглашение. Продолжить её оформление?',
        title: 'Заявка уже начата',
      },
      duplicateBin: 'Организация с таким БИН уже входит в состав',
      headOffice: 'Головной офис',
      initial: 'Исходные данные',
      listTitle: 'Допсоглашения',
      noChanges: 'Измените хотя бы одно значение, чтобы отправить заявку',
      number: 'Номер',
      oked: 'ОКЭД',
      phone: 'Номер телефона',
      policyholderData: 'Данные страхователя',
      recalculating: 'Сумма пересчитывается — подождите, пока обновятся итоги',
      registrationDate: 'Дата регистрации',
      registrationDepartment: 'Орган юстиции',
      removeBranch: 'Уверены, что хотите удалить филиал?',
      removeBranchConfirm: 'Уверены, что хотите удалить филиал?',
      removeBranchQuestion: 'Уверены, что хотите удалить филиал?',
      reRegistrationDate: 'Дата перерегистрации',
      riskClass: 'Класс профессионального риска',
      sent: 'Заявка на доп. соглашение отправлена',
      signer: 'Подписант',
      signerIin: 'ИИН подписанта',
      signerJobName: 'Должность',
      signerJobNameOther: 'Другая должность',
      status: 'Статус',
      statuses: {
        ACTIVATING: 'Активируется',
        ACTIVE: 'Действует',
        APPROVED: 'Согласовано',
        AWAITING_BCC_LIFE_SIGNATURE: 'Ожидает подписи BCC Life',
        AWAITING_CLIENT_SIGNATURE: 'Ожидает вашей подписи',
        DRAFT: 'Черновик',
        INVOICE_ISSUED: 'Счёт выставлен',
        PAID: 'Оплачено',
        PENDING_DS_MANAGER: 'На согласовании',
        PENDING_STATISTICIAN: 'У статиста',
        REJECTED_BY_DS_MANAGER: 'Отклонено',
        RETURNED_BY_STATISTICIAN: 'Возвращено на доработку',
        SIGNED: 'Подписано',
      },
      steps: {
        branches: 'Данные филиалов',
        contract: 'Данные договора',
        headOffice: 'Данные головного офиса',
      },
      surcharge: 'Сумма к доплате(предварительный расчет)',
      title: 'Доп. соглашение',
      yes: 'Да',
    },
    agreement: {
      userAgreement: 'Условия Пользовательского соглашения',
    },
    annuity: {
      annuityApplication: 'Заявление на ППА',
      applicationNumber: '№ заявления',
      applyAnnuity: 'Подать заявление на ППА',
      submitApplication: 'Ваше извещение прошло все проверки и теперь вы можете подать заявление на ППА',
      whatNext: 'Что дальше',
    },
    applications: {
      application: 'Заявка',
      applications: 'Страховые случаи',
      notFound: 'Здесь пока ничего нет',
    },
    auth: {
      agrrement: 'С условиями Пользовательского соглашения ознакомлен и согласен',
      bin: 'БИН/ИИН',
      cyberHygiene: {
        copy: 'Регулярно создавайте резервные копии важных данных (фотографии, документы, контакты) и храните в безопасном месте.',
        hygiene: 'Кибергигиена: Ваша роль в защите цифрового пространства.',
        info: 'В современном цифровом мире кибергигиена очень важна- соблюдение простых правил поможет защитить вас и ваши данные от злоумышленников.',
        link: 'Проверяйте URL-адреса сайтов, на которые заходите, доверяйтесь только официальным источникам. Не переходите по подозрительным ссылкам и не открывайте вложения от неизвестных отправителей. ',
        password:
          'Используйте сложные пароли, содержащие буквы (верхний и нижний регистр), цифры и символы. Регулярно меняйте пароли.',
        personalInfo:
          'Не публикуйте личную информацию (адрес, номер телефона, дату рождения) в социальных сетях и на общедоступных ресурсах.',
        recommended: 'Рекомендуемые меры безопасности:',
        safety:
          'Соблюдение этих простых правил кибергигиены поможет вам и вашим близким оставаться в безопасности в цифровом мире. Помните, что безопасность в интернете – это наша общая ответственность.',
        update:
          'Установите и регулярно обновляйте антивирусное программное обеспечение. Включите автоматическое обновление антивируса.',
      },
      email: 'Email',
      emailOtpMessage: 'На ваш email придет одноразовый код для подтверждения',
      enter: 'Войти',
      enterCode: 'Введите код',
      errors: {
        basic: 'Что-то пошло не так, попробуйте позднее.',
        bccMail: 'info@bcclife.kz',
        INCORRECT_PHONE_NUMBER:
          'Уважаемый клиент, ваш номер телефона не зарегистрирован. Пожалуйста, обратитесь в службу поддержки для получения помощи',
        notFound: 'Пользователь с введеным ИИН не найден. Зарегистрируйтесь.',
        notNumber: 'Номер не зарегестрирован',
        otpCodeNotValid: 'Введен неверный СМС-код. Попробуйте еще раз',
        USER_BLOCKED: 'Введенный номер заблокирован.',
        USER_EXISTS_BY_BIN: 'Введенный ИИН/БИН уже зарегистрирован. Войдите в систему.',
        USER_EXISTS_BY_IDENTIFIER: 'Введенный ИИН/БИН уже зарегистрирован. Войдите в систему.',
        USER_EXISTS_BY_PHONE: 'Введенный номер уже зарегистрирован. Войдите в систему.',
        USER_NOT_FOUND: 'Введенный номер ещё не зарегистрирован. Зарегестрируйтесь.',
        userNotFound: 'Проверьте правильность набранного номера',
      },
      getCode: 'Получить код',
      getSms: 'Получить код',
      haveAnAccount: 'Уже есть аккаунт?',
      iin: 'ИИН/БИН',
      login: 'Вход в личный кабинет',
      loginBy: 'Войти по',
      mail: 'вашу почту',
      noAccount: 'Нет аккаунта?',
      otpCode: 'ОТР-код',
      otpMessage: 'На ваш телефон придет ОТР-код для подтверждения',
      phone: 'ваш номер',
      phoneNumber: 'Номер телефона',
      phoneRadio: 'Номеру телефона',
      register: 'Зарегистрироваться',
      registration: 'Регистрация',
      repeatedCode: 'Запросить код повторно',
      repeatedCodeInSeconds: 'Запросить код повторно через {{seconds}}',
      sentCodeOne: 'Мы выслали ',
      sentCodeToEmail: 'Мы мы выслали код на вашу почту',
      sentCodeToPhone: 'Мы выслали код на ваш номер ',
      sentCodeTwo: 'код на',
      subscribe: 'Подписать',
      welcome: 'Добро пожаловать',
    },
    bankName: {
      bcc: 'Банк ЦентрКредит',
      forte: 'ForteBank',
      halyk: 'Народный банк Казахстана',
      kaspi: 'Kaspi Bank',
    },
    chooseLanguage: 'Выберите язык',
    claimDocuments: {
      requirement: {
        documentTemplate: 'Шаблон документа',
        listDocuments: 'Список приложенных документов',
        requestDocuments:
          'Для подачи заявления на выплату необходимо собрать и предоставить перечень необходимых документов.',
        requiredDocuments: 'Перечень необходимых документов',
        templateTitle: 'Шаблон документа о заработной плате.xlsx',
        verificationDocuments: 'Сбор и проверка документов',
      },
    },
    claimsStatements: {
      applicationPage: ' Страница заявления',
      clientIdentifier: 'ИИН/БИН клиента',
      clients: {
        absent: 'Отсутствует',
        additionalInfo: 'Иная информация',
        additionalInfoIfPresent: 'Иная информация (при наличии)',
        addRepresentative: 'Добавить представителя',
        bankCode: 'КБе',
        bankName: 'Наименование банка',
        bankRequisites: 'Банковские реквизиты',
        beneficialControlType: 'Порядок осуществления бенефициарным собственником контроля',
        benificiar: 'Бенифициар',
        bikCode: 'БИК',
        binCode: 'БИН банка',
        birthAddress: 'Место рождения',
        birthDate: 'Дата рождения',
        checkInformation:
          'Проверьте, пожалуйста, указанные данные. Если информация неверна или устарела, перейдите на страницу договора в личном кабинете и обновите её.',
        citizenship: 'Гражданство',
        clarifyIsPdl: 'Уточнение ПДЛ',
        comment: 'Комментарий',
        countryResidence: 'Страна резидентства',
        dataBeneficialOwner: 'Данные по бенефициарным собственникам',
        director: 'Директор',
        economicActivity: 'Вид экономической деятельности или ОКЭД',
        economicSector: 'Код сектора экономики',
        entity: 'Юридических лиц',
        expireDate: 'Дата окончания действия документа',
        fio: 'ФИО',
        fioBeneficial: ' ФИО бенефициара',
        fioFirstManager: 'ФИО первого руководителя',
        fioFounder: 'ФИО учредителя',
        fioTitle: 'ФИО/Название',
        fioVictim: 'ФИО потерпевшего',
        firstManager: 'Данные по первому руководителю',
        founder: 'Учредитель',
        foundersLength: 'Общее количество участников, учредителей',
        fullAddress: 'Место нахождения организации',
        gender: 'Пол представителя',
        genderVictim: 'Пол потерпевшего',
        iban: 'IBAN',
        iin: 'ИИН',
        iinBin: 'ИИН/БИН',
        iinCountryRegistration: 'ИИН в стране регистрации',
        iinFirstManager: 'ИИН первого руководителя',
        iinPolicyholder: 'БИН/ИИН Страхователя',
        iinSoloPolicyholder: 'ИИН Страхователя',
        iinVictim: 'ИИН потерпевшего',
        individual: 'Физических лиц',
        infBeneficialOwner: 'Сведения по бенефициарному собственнику',
        infFounder: 'Данные по учредителю',
        infoAboutVictim: 'Данные о потерпевшем',
        infoRepresentative: 'Данные по представителю',
        informationFounder: 'Сведения по учредителю',
        infoVictim: 'Данные потерпевшего',
        isPdl: 'Принадлежит ли и/или причастен ли к ПДЛ, его супруге (супругу) и близким родственникам',
        isResidence: 'Признак резидентства',
        issueDate: 'Дата выдачи документа',
        issueOrganization: 'Выдано(кем)',
        legalAddress: 'Юридический адрес',
        nameHostOrganization: 'Наименование принимающей организации',
        naming: 'Наименование',
        numberDocument: '№ документа',
        oked: 'Основной ОКЭД',
        orgFullName: 'Полное наименование Страхователя',
        orgIncorporationDepartment: 'Орган юстиции, зарегистрировавший орг.',
        orgIncorporationLastDate: 'Дата перерегистрации',
        policyholder: 'Данные страхователя',
        region: 'Регион',
        registrationAddress: 'Адрес регистрации',
        registrationCertificate: {
          certificateSeries: 'Серия',
          notificationDate: 'Дата регистрации',
          number: 'Номер',
          title: 'Свидетельство о регистрации',
        },
        registrationDate: 'Дата регистрации',
        registrationNumber: 'Гос. регистрационный номер',
        representative: 'Представитель',
        residenceCountry: 'Страна резиденства',
        residentialAddress: 'Фактический адрес / Место проживания',
        riskClass: 'Класс профессионального риска',
        talon: 'Талон',
        talonNotifyCreated: 'Дата приема уведомления по талону',
        talonNumber: 'Номер талона',
        taxResidenceCountry: 'Налоговое резидентство',
        type: 'Тип',
        typeDocument: 'Вид документа',
      },
      contractNumber: 'Номер договора',
      documents: {
        beneficiaryConsent: 'Согласие выгодоприобретателя',
        certificate: 'Справка о принятых документах',
        paymentStatement: 'Заявление на выплату',
        victimConsent: 'Согласие потерпевшего',
      },
      download: 'Скачать заявление',
      enterClientIdentifier: 'Введите ИИН / БИН клиента',
      enterContractNumber: 'Введите номер договора',
      enterStatementId: 'Введите ID заявления',
      enterStatementNumber: 'Введите номер заявления',
      enterVictimFio: 'Введите ФИО потерпевшего',
      enterVictimIdentifier: 'Введите ИИН потерпевшего',
      generatedPaymentPdf: 'Сгенерированное заявление на выплату.pdf',
      informationApplication: 'Данные по заявлению',
      noticeNumber: '',
      noticeType: 'Тип заявления',
      product: 'Продукт',
      sentApplication:
        'Заявление успешно отправлено и сейчас находится в обработке. Пожалуйста, дождитесь решения страховой компании — мы уведомим вас, как только оно будет принято.',
      statementDate: 'Дата заявления',
      statementId: 'ID Заявления',
      statementNumber: 'Номер заявления',
      title: 'Заявления на выплату',
      victimFio: 'ФИО потерпевшего',
      victimIdentifier: 'ИИН потерпевшего',
    },
    clear: 'Очистить',
    common: {
      currency: 'Валюта',
    },
    contractsPage: {
      annualWageFund: 'ГФОТ',
      annuityPayment: 'Аннуитетная выплата',
      averageMonthlySalary: 'Средне-месячная зарплата',
      beginDate: 'Дата начала страховой защиты',
      branchesData: 'Данные филиалов',
      branchNumber: 'Филиал {{number}}',
      cardDocument: 'Карточка электронного документа',
      cardDocumentEnpf: 'Карточка электронного документа ЕНПФ',
      conclusionDate: 'Дата заключения',
      consent: 'Согласие на сбор и обработку данных ЕНПФ',
      contract: 'Договор',
      contractPdf: 'Договор',
      contracts: 'Договоры',
      cover: 'Покрытие',
      coverageLife: '1. Смерть 2. Инвалидность 3. Временная утрата трудоспособности',
      ddc: 'Карточка электронного документа',
      disabilityStatus: 'Наличие инвалидности',
      dpvSum: 'Сумма ДПВ',
      dpvSumTooltip: 'ДПВ — это дополнительные пенсионные взносы, которые вы сами вносите на отдельный счет в ЕНПФ.',
      dsjProgram: 'Программа',
      dsjPrograms: {
        COMFORT: 'Комфорт',
        STANDARD: 'Стандарт',
      },
      dsjRisks: {
        DEATH_ANY_CAUSE: 'Смерть по любой причине',
        DISABILITY_1_2: 'Инвалидность I и II группы',
        TEMPORARY_DISABILITY: 'Временная утрата трудоспособности',
      },
      employeesCount: 'Количество сотрудников',
      endDate: 'Дата окончания страховой защиты',
      endowmentCover: '1. Дожитие до окончания полиса 2. Смерть от НС или заболевания',
      exchangeRateAtTheTimeOfPurchase: 'Курс валюты на момент покупки',
      ezSigner: 'Представление ezSigner',
      ezSignerEnpf: 'Представление ezSigner ЕНПФ',
      gpEndDate: 'Дата окончания гарантированного периода',
      gpStartDate: 'Дата начала гарантированного периода',
      guaranteedPaymentTerm: 'Гарантированный срок выплат',
      guaranteedPaymentYears: 'Гарантированный срок выплат в годах',
      infoContract: 'Данные договора',
      insuranceAmount: 'Страховая сумма',
      insuranceAmountInCurrency: 'Страховая сумма в валюте',
      insuranceApplication: 'Заявление на страхование',
      insuranceCoefficient: 'ПК',
      insuranceDividend: 'Страховой дивиденд',
      insurancePremium: 'Страховая премия',
      insurancePremiumWithCoefficient: 'Страховая премия с учетом ПК',
      labelAlert: 'Внимание! По данному договору было направлено Заявление на расторжение',
      lifeCover:
        '1. Уход из жизни застрахованного 2. Установление инвалидности 1, 2 группы в результате несчастного случая или заболеваний 3. Временная утрата трудоспособности в результате несчастного случая',
      listDocuments: 'Список документов',
      mainOffice: 'Головной офис',
      mainOked: 'Основной ОКЭД',
      nextPaymentAmount: 'Сумма платежа',
      nextPaymentDate: 'Дата платежа',
      // «в течение» требует родительного падежа: 1 дня, 2 дней, 5 дней.
      nextPaymentDeadline_few: 'Внимание! Следующий платеж необходимо внести в течение {{count}} дней',
      nextPaymentDeadline_many: 'Внимание! Следующий платеж необходимо внести в течение {{count}} дней',
      nextPaymentDeadline_one: 'Внимание! Следующий платеж необходимо внести в течение {{count}} дня',
      nextPaymentDeadlineToday: 'Внимание! Следующий платеж необходимо внести сегодня',
      nextPaymentDownloadInvoice: 'Скачать счет на оплату',
      nextPaymentInfo: 'Информация о следующем платеже',
      noData:
        'Нет договоров, соответствующих вашим условиям. Если вы применили фильтры или поисковый запрос - попробуйте их изменить.',
      opvSum: 'Сумма ОПВ',
      opvSumTooltip: 'ОПВ — это обязательные пенсионные взносы, из которых формируется основная пенсия.',
      organizationLocation: 'Место нахождения организации',
      osrnsCover:
        ' 1. Потерянный доход в случае ухода из жизни работника 2. Потерянный доход в случае утраты профессиональной трудоспособности',
      osrnsEzSigner: 'Представление ezSigner',
      paidByContract: 'Оплачено по договору',
      paidLabel: 'Оплачено',
      paymentInvoice: 'Счет на оплату',
      paymentInvoiceNextDate: 'Дата следующего платежа',
      paymentStatusCancelled: 'Отменен',
      paymentStatusPaid: 'Оплачен',
      paymentStatusPartiallyPaid: 'Частично оплачен',
      paymentStatusUnpaid: 'Не оплачен',
      policyHolderBin: 'БИН Страхователя',
      policyHolderFullName: 'Полное наименование Страхователя',
      product: 'Продукт',
      referralProgram: 'Реферальная программа',
      referralProgramDescription:
        'Создайте персональную реферальную ссылку и поделитесь ею с друзьями или знакомыми. Если по вашей ссылке будет оформлен договор, вы получите вознаграждение согласно условиям реферальной программы.',
      remainingToPay: 'Остаток к оплате',
      riskClassShort: 'КПР',
      selfAmount: 'Сумма собственных средств',
      selfAmountTooltip: 'Личные средства, которые вы внесли в BCC Life.',
      tariff: 'Тариф',
      textAlert: 'Для отслеживания статуса по расторжению, пожалуйста, перейдите во вкладку "Расторжение"',
      totalAnnuityCost: 'Итого стоимость аннуитета',
      tranche: '{{number}}-й транш',
      trancheDueDate: 'Дата оплаты {{date}}',
      trancheFirst: 'Первый транш',
      trancheFourth: 'Четвертый транш',
      tranchePaidPercent: '{{percent}}% оплачено',
      trancheRemaining: 'Остаток: {{amount}}',
      trancheSecond: 'Второй транш',
      trancheThird: 'Третий транш',
      yourContracts: 'Договоры страхования',
    },
    details: {
      contractEndowmentName: 'Страхование жизни с индексацией',
      contractLifeName: 'Страхование жизни',
      contractNumber: 'Номер договора',
      contractOSRNSName: 'Обязательное страхование работников',
      contractsNumber: '№ договора',
      contractTerminate: 'Расторгнуть договор',
      date: 'Дата и время заявления:',
      dateUpdate: 'Дата и время последнего обн.:',
      download: 'Скачать',
      insuranceAmount: 'Страховая сумма',
      insurancePremium: 'Страховая премия',
      insured: 'Застрахованный:',
      moreDetailed: 'Подробнее',
      notifyInsured: 'Известить о страховом случае',
      status: 'Статус:',
    },
    detailsPage: {
      accept: 'Ваше заявление на выплату принято',
      acceptText:
        'В течении 5 дней выплата поступит на ваш счет. В случае возникновения вопросов свяжитесь со службой поддержки.',
      attackIt: 'Прикрепите файл (-ы)',
      attention14Days:
        'С момента заключения договора страхования прошло 14 дней. В соответствии с условиями договора, в случае его расторжения уплаченная сумма не подлежит возврату.',
      attentionText:
        'Для рассмотрения Вашего обращения по заявленному событию, просим предоставить следующий комплект документов:',
      attentionTitle: 'Внимание! Необходимо загрузить документы',
      certified: 'Внимание! Необходимые копии документа-(ов) должны быть нотариально заверенными',
      choose: 'Выбрать файл',
      confirmation: 'Я подтверждаю, что загрузил все необходимые документы',
      data: 'Данные:',
      fileFormat: 'Допустимые форматы загрузки файлов: pdf. Размер загружаемого файл не должен превышать 30 MB.',
      format:
        'Допустимые форматы загрузки файлов: pdf, doc, docx, jpg, jpeg, png, svg. Размер загружаемого файл не должен превышать 30 MB.',
      reasonTermination: 'Для рассмотрения Вашего обращения, пожалуйста, укажите причину расторжения договора',
      rejected: 'Ваше заявление отклонено',
      rejectedText: 'Для того, чтобы получить информацию о причине отклонения свяжитесь со службой поддержки',
      requiredDocuments: 'Список обязательных документов',
      select: 'Перетащите файл или выберите на компьютере',
      send: 'Отправить',
      stepFour: '4 Шаг',
      stepFourText: 'Заявление принято',
      stepOne: '1 Шаг',
      stepOneText: 'Извещение о страховом случае',
      stepThree: '3 Шаг',
      stepThreeText: 'Подать заявление на страховую выплату',
      stepTwo: '2 Шаг',
      stepTwoText: 'Загрузка документов',
    },
    download: 'Скачать',
    error: {
      notFound: 'Страница не найдена',
      notifyInsured: 'Известить о страховом случае',
      reloudPage: 'Попробуйте перезагрузить страницу',
    },
    faq: 'Часто задаваемые вопросы',
    general: {
      address: 'Адрес',
      begin: 'Начать',
      birthDate: 'Дата рождения',
      citizenship: 'Гражданство',
      client: 'Клиент',
      clientStatus: {
        NEW: 'Извещение на согласовании',
      },
      conclusionDate: 'Дата заключения',
      contact: {
        contactInfo: 'Контактные данные',
        email: 'E-mail',
        phoneNumber: 'Номер телефона',
      },
      createdDate: 'Дата создания',
      documentNumber: 'Номер документа',
      enterClientFio: 'Введите ФИО клиента',
      enterConclusionDate: 'Введите дату заключения',
      enterContractId: 'Введите ID договора',
      enterContractNumber: 'Введите номер договора',
      enterIinBin: 'Введите ИИН / БИН',
      enterInsuranceAmount: 'Введите страховую сумму',
      enterInsuranceEndDate: 'Введите дату окончания страховой защиты',
      enterInsurancePremium: 'Введите страховую премию',
      enterInsuranceStartDate: 'Введите дату начала страховой защиты',
      executor: 'Исполнитель',
      gender: 'Пол',
      iinBinClient: 'ИИН / БИН клиента',
      insuranceEndDate: 'Дата окончания страховой защиты',
      insuranceStartDate: 'Дата начала страховой защиты',
      naming: 'Наименование',
      note: 'Примечание',
      notFound: 'Не найдено',
      optionLists: {
        // Данный объект был создан, так как переводы ЛК отличаются
        contractStatuses: {
          [IEnumContractStatus.ACTIVE]: 'Действующий',
          [IEnumContractStatus.EXPIRED]: 'Завершен',
          [IEnumContractStatus.IN_PROCESSING_PAYMENT]: 'Требуется обработка заявления',
          [IEnumContractStatus.REPLACED]: 'Недействителен',
          [IEnumContractStatus.TERMINATED]: 'Расторгнут',
          [IEnumContractStatus.WAITING_FOR_PAYMENT_APPLICATION]: 'Ожидаем заявления на выплату',
        },
      },
      registrationAddress: 'Адрес регистрации',
      status: 'Статус',
      tableNoData:
        'Нет записей по заявкам, соответствующих вашим условиям. Если вы применили фильтры или поисковый запрос - попробуйте их изменить.',
      thanks: 'Спасибо!',
      underwriter: 'Ответственный',
      updatedDate: 'Дата редактирования',
    },
    noDocuments: {
      goSite: 'Перейти на сайт',
      notice: 'вы можете подать извещение о страховом случае',
      site: 'Вы можете ознакомиться с продуктами на нашем сайте',
    },
    notice: {
      infoMessages: {
        accidentActNotReceived:
          'Необходимо предоставить в оригинале лично по адресу: город Алматы, проспект Достык 188, бизнес-центр Кулан. Без этого рассмотрение не может быть завершено.',
        accidentActReceived:
          'Дальнейшие действия и инструкции вы получите на ваш электронный адрес. Пожалуйста, следите за уведомлениями на почте.',
        isLessThanSixMonths:
          'Срок действия указанного документа истекает менее чем через 6  месяцев или уже истек, что не соответствует требованиям. Пожалуйста, обновите информацию, чтобы продолжить использование сервиса без ограничений.',
        newClaim: 'В настоящее время данные находятся в обработке у менеджера по выплатам.',
        onApproval:
          'Для рассмотрения Вашего обращения по заявленному событию, просим предоставить перечень первичных документов. Следующий список документов будет запрошен после утверждения списка текущих документов.',
      },
    },
    notices: {
      alertContract: 'По вашему заявлению сформирован договор предпенсионного аннуитета.',

      apply: {
        consent: {
          badge: {
            declined: 'Согласие отклонено',
            granted: 'Согласие получено',
            required: 'Требуется согласие',
            sent: 'Согласие отправлено',
          },
          confirmed: 'Подтвердил',
          declinedAlert:
            'Согласие отклонено. Без согласия мы не можем продолжить оформление заявки. Вы можете запросить повторно',
          identifierNotFound: 'Введённый ИИН некорректен или не найден в системе',
          introNotice:
            'Необходимо получить согласие потерпевшего на обработку персональных данных. Запросите СМС-подтверждение с номера 1414',
          pendingAlert: 'Проверьте входящее СМС и ответьте на сообщение с номера 1414',
          pendingAlertTitle: 'Согласие ещё не зафиксировано',
          repeat: 'Запросить повторно',
          repeatIn: 'Отправить согласие повторно через {{seconds}} сек',
          request: 'Запросить согласие',
          serviceUnavailable:
            'Сервис согласия временно недоступен. Пожалуйста, попробуйте позже — введённые данные сохранены',
          timeoutAlert: 'Срок действия запроса истёк. Пожалуйста, запросите согласие повторно',
        },
        description: 'Для уведомления страховой компании о наступлении страхового случая необходимо создать извещение.',
        form: {
          alert: 'Для подачи заявления заполните все обязательные поля',
          alertTitle: 'Заполните обязательные поля',
          citizenship: 'Гражданство',
          contractNumber: 'Номер договора',
          dateAndTime: 'Дата и время',
          dateOfBirth: 'Дата рождения',
          dateOfIssue: 'Дата выдачи',
          death: 'Смерть',
          documentNumber: 'Номер документа',
          documentType: 'Тип документа',
          email: 'E-mail',
          enterMessage: 'Введите сообщение',
          eventHappenned: 'Событие которое произошло',
          eventPlaced: 'Место события',
          expirationDate: 'Дата окончания срока действия',
          female: 'Женский',
          fillDetails: 'Заполните данные:',
          firstName: 'Имя',
          iin: 'ИИН',
          insuredEventDateAndTime: 'Дата и время страхового случая',
          issuingAuthority: 'Орган выдачи документа',
          lastName: 'Фамилия',
          male: 'Мужской',
          middleName: 'Отчество',
          no: 'Нет',
          noIin: 'Нет ИИН',
          nonResident: 'Нерезидент РК',
          occupationalDisease: 'Профессиональное заболевание',
          onsuranceEventDesciption: 'Описание страхового случая',
          phoneNumber: 'Номер телефона',
          registrationAddress: 'Адрес регистрации',
          resident: 'Резидент РК',
          selectContractNumber: 'Выберите номер договора',
          selectCountry: 'Выберите страну',
          selectCountryResidence: 'Выберите страну резидентства',
          selectCountryTaxResidence: 'Выберите страну налогового резидентства',
          selectFromTheOptionsBelow: 'Выберите из перечисленных ниже вариантов',
          specifyLocationOfIncident: 'Укажите место проишествия',
          taxResidenceCountry: 'Выберите страну налогового резиденства',
          workInjury: 'Трудовое увечье',
          yes: 'Да',
        },
        identityDocument: 'Документ, удостоверяющий личность',
        title: 'Извещение о страховом случае',
        victimData: 'Данные потерпевшего',
        warning:
          'В случае наступления страхового случая, Вам необходимо создать извещение о страховом случае в течение трёх календарных дней с момента его наступления. Несоблюдение срока может повлиять на рассмотрение и выплату страхового возмещения. После подачи извещения вы сможете перейти к подаче заявления на выплату, приложив необходимые документы.',
      },
      checkCorrect: 'Пожалуйста, проверьте правильность ввода и попробуйте снова.',
      claimStatements: {
        applicationNumber: '№ заявления',
        compensationType: 'Тип возмещения',
        createdDate: 'Дата создания',
        paymentType: 'Тип оплаты',
        status: 'Статус',
        title: 'Заявления',
      },
      contractNum: '№ договора',
      contractPPA: 'Договор ППА',
      enterClaimNumber: 'Введите номер извещения',
      enterClientIdentifier: 'Введите ИИН / БИН клиента',
      enterNoticeId: 'Введите ID извещения',
      enterVictimFio: 'Введите ФИО потерпевшего',
      enterVictimIdentifier: 'Введите ИИН потерпевшего',
      formatDocuments:
        'Допустимые форматы загрузки файлов: pdf, doc, docx, jpg, png, xlsx, xls. Размер загружаемого файл не должен превышать 30 MB.',
      furtherActions: {
        documents: {
          DEATH: {
            copyBankDetails: 'Копия банковских реквизитов счета получателя.',
            copyDocument:
              'Нотариально засвидетельствованная копия документа, подтверждающего право выгодоприобретателя на возмещение вреда в случае смерти работника;',
            digitalCopy: 'Цифровая копия документа, удостоверяющего личность выгодоприобретателя;',
          },
          INJURY_OR_DISEASE: {
            amountSocialPayment:
              'Копия справки территориального подразделения уполномоченного органа о размере назначенной социальной выплаты по случаю утраты трудоспособности либо отказе в ее назначении;',
            confirmationMedicalExpenses:
              'Документы, подтверждающие фактически понесенные расходы на лечение (счет-фактура, кассовый чек и другие);',
            copyBankDetails: 'Копия банковских реквизитов счета получателя.',
            copyDisability: 'Копия справки об инвалидности;',
            copyLossStatement:
              'Копия справки территориального подразделения уполномоченного органа об установлении утраты профессиональной трудоспособности;',
            copyNeedHelp:
              'Копия справки территориального подразделения уполномоченного органа о нуждаемости в дополнительных видах помощи и ухода;',
            digitalCopy: 'Цифровая копия документа, удостоверяющего личность пострадавшего работника;',
            documentPresenceDisease:
              'Копия документа, подтверждающего наличие профессионального заболевания, выданная организацией здравоохранения, оказывающей специализированную медицинскую помощь в области профессиональной патологии и экспертизы;',
          },
        },
        listDocuments: 'Список необходимых документов',
        sendTo:
          'Оригиналы документов или нотариально заверенные копии направлять по адресу: A25D6X2, Республика Казахстан, г. Алматы, проспект Достык, 188, БЦ Kulan, 2 этаж, тел.: +77003702128, 8 (727) 248 62 74, e-mail: claims@bcclife.kz',
        whatsNext: 'Что дальше',
      },
      kdpPdHistory: {
        checkType: 'Тип проверки',
        consentResponseAt: 'Дата и время согласия/несогласия',
        consentSentAt: 'Дата и время отправки согласия',
        consentStatus: 'Статус согласия',
        dateTime: 'Дата и время согласия',
        getSMSAgreement: 'Получить СМС согласие',
        smsAgreementSuccessfullySent: 'СМС согласие успешно отправлено',
        title: 'Согласие потерпевшего',
      },
      notFound:
        'Не найдено. Нет извещений, соответствующих вашим условиям. Если вы применили фильтры или поисковый запрос - попробуйте их изменить.',
      notice: 'Извещение',
      noticeDate: 'Дата извещения',
      noticeId: 'ID извещения',
      noticeNum: '№ извещения',
      noticeNumber: 'Номер извещения',
      notices: 'Журнал извещений',
      noticeType: 'Тип извещения',
      notificationNS: 'Извещение НС',
      notificationPPA: 'Извещение о ППА',
      oppvCheckRequest: {
        eventId: 'ID события',
        registrationEventDateTime: 'Дата и время регистрации события',
        responseCode: 'Код ответа',
        responseCodeDescription: 'Описание кода ответа',
        title: 'Регистрация проверки по ОППВ в ЕСБД',
      },
      oppvCheckResponse: {
        mandatoryProfessionalInsuranceContributions: 'Обязательные профессиональные страховые взносы',
        messageId: 'ID сообщения',
        paymentDate: 'Дата платежа',
        paymentPeriod: 'Период платежа',
        personCitizenship: 'Гражданство лица',
        personCitizenshipOptions: {
          '1': 'Соответствует',
          '2': 'Не соответствует',
        },
        personOppvOptions: {
          '1': 'Не соответствует (меньше 84 месяца)',
          '2': 'Cоответствует, 84 месяца и более (исключаем платежи, по которым осуществлен возврат плательщику)',
        },
        personStateOptions: {
          '1': 'Соответствует',
          '2': 'Не соответствует',
        },
        personStatus: 'Статус лица',
        personWorkingConditionOptions: {
          '1': 'Расторжение с трудовым договором (вредные условия труда)',
          '2': 'Переход на легкие условия труда (заключение дополнительного договора)',
          '3': 'Отсутствие договора',
        },
        reportDate: 'Дата отчета',
        requestId: 'ID запроса',
        responseDate: 'Дата ответа',
        responseDateCurrent: 'Дата ответа (Текущее время запроса)',
        title: 'Результат проверки по ОППВ в ЕСБД',
        workingConditions: 'Рабочие условия',
      },
      paymentApplication: {
        blockTitle: 'Заявление на выплату',
        compensationType: {
          sanatoriumLimitText: 'Заявление на это возмещение уже было подано. Выберите другой тип возмещения',
          sanatoriumLimitTitle: 'Внимание! У вас уже есть заявление на санаторно-курортное лечение',
          selectTypeOfRefund: 'Выберите тип возмещения',
          typeOfRefund: 'Тип возмещения',
        },
        consent:
          'Нажимая кнопку "Продолжить" я даю свое согласие на <termsConditionsLink>сбор, обработку и использование персональных данных работника</termsConditionsLink>',
        continueButton: 'Продолжить',
        createButton: 'Создать заявление на выплату',
        documents: {
          DEATH: {
            bankDetails: 'Банковские реквизиты',
            confirmationExpenses: 'Документы подтверждающие понесенные расходы',
            otherDocuments: 'Иные документы',
          },
          INJURY_OR_DISEASE: {
            bankDetails: 'Банковские реквизиты',
            certificateOfNeed: 'Справка о нуждаемости',
            confirmationExpenses: 'Документы подтверждающие понесенные расходы',
            otherDocuments: 'Иные документы',
          },
        },
        documentsBannerText:
          'Для подачи заявления на выплату необходимо собрать и предоставить перечень документов. Убедитесь что у вас есть эти документы в электронном варианте.',
        documentsBannerTitle: 'Внимание! Необходимо загрузить документы',
        introTitle: 'Подача заявления на выплату по Страховому случаю',
        listDocuments: 'Список необходимых документов',
        originalDocumentBanner:
          'Внимание! Данный документ необходимо предоставить страховой компании в оригинале любым удобным способом: курьером, почтовым отправлением либо при личном посещении офиса. Адрес страховой компании: г. Алматы, проспект Достык 188, бизнес-центр Кулан',
        step1: {
          clarifyPdlLabel: 'Уточните ПДЛ',
          emailLabel: 'E-mail',
          pdlHint:
            'Публичное должностное лицо (ПДЛ) — лицо, занимающее ответственную государственную должность; должностное лицо; лицо, уполномоченное на выполнение государственных функций; лицо, исполняющее управленческие функции в государственной организации или субъекте квазигосударственного сектора; лицо, назначаемое или избираемое, занимающее какую-либо должность в законодательном, исполнительном, административном, судебном органах или вооруженных силах иностранного государства; лицо, выполняющее какую-либо публичную функцию для иностранного государства; лицо, занимающее руководящую должность в организациях, созданных странами на основе соглашений, которые имеют статус международных договоров.',
          pdlQuestion: 'Принадлежит ли потерпевший, супруг(а) или близкие родственники к ПДЛ?',
          title: 'Заявление на выплату по Страховому случаю',
          victimInfoTitle: 'Сведения о Потерпевшем',
        },
        step2: {
          dateInsuredEvent: 'Дата и время страхового случая',
          descriptionNs: 'Описание НС',
          disabilityPercent: '% Степень утраты профессиональной трудоспособности потерпевшего ',
          event: 'Событие которое произошло',
          eventLocation: 'Место события',
          reasonNs: 'Причина НС',
        },
        step3: {
          beneficiaryLabel: 'Выгодоприобретатель',
          enterBankRequisites: 'Введите банковские реквизиты',
          hint: 'Выгодоприобретатель - лицо, которое получит страховую выплату.',
          ibanHint: 'IBAN должен начинаться с KZ',
          otherConsentNotice:
            'Необходимо получить согласие выгодоприобретателя на обработку персональных данных. Запросите СМС-подтверждение с номера 1414',
          pdlQuestion: 'Принадлежит ли Выгодоприобретатель, супруг(а) или близкие родственники к ПДЛ?',
          selectVariant: 'Выберите один из вариантов',
          title: 'Информация о выгодоприобретателе',
        },
        step4: {
          title: 'Загрузите необходимые документы',
        },
        step5: {
          applicationInfo: 'Сведения о заявлении',
          applicationType: 'Тип заявления',
          confirmButton: 'Подтверждаю',
          consentCheckbox:
            'Я ознакомлен(а) и согласен(а) с условиями <documentLink>Заявления на выплату по страховому случаю</documentLink>.',
        },
        steps: {
          beneficiary: 'Выгодоприобретатель',
          confirmation: 'Подтверждение',
          descriptionNs: 'Описание НС',
          documents: 'Документы',
          info: 'Сведения',
        },
        success: {
          applicationNumber: '№ заявления',
          applicationPageButton: 'Страница заявления',
          description:
            'Заявление успешно отправлено и сейчас находится в обработке. Пожалуйста, дождитесь решения страховой компании — мы уведомим вас, как только оно будет принято.',
          downloadButton: 'Скачать заявление',
          title: 'Спасибо! Мы получили ваше заявление',
        },
      },
      title: 'Извещения',
      uploadDocument: 'Загрузите документ',
      victim: {
        applicationStatus: 'Статус заявки',
        documentType: 'Тип документа',
        expirationDate: 'до истечения срока менее 6 месяцев',
        identityDocument: 'Документ удостоверяющий личность',
        issueDate: 'Дата выдачи',
        issuedBy: 'Орган выдачи документа',
        validUntil: 'Действует до',
        victimData: 'Данные потерпевшего',
        victimPerson: 'Потерпевший',
      },
    },
    payment: {
      agree: 'Согласен',
      agreeText:
        'Я ознакомлен с суммой и даю свое согласие на сбор, обработку и использование моих персональных данных',
      disagree: 'Не согласен',
      info: 'БИК банка:',
      nameBank: 'Наименование банка:',
      number: 'Номер счета:',
      requisits: 'Реквизиты банковского счета для выплаты:',
      result: 'Итоговая сумма страховой выплаты будет составлять:',
      send: 'Отправить',
    },
    personalDataProcessing:
      'Нажимая кнопку "Далее" я подтверждаю <termsConditionsLink>на сбор, обработку и использование персональных данных работника</termsConditionsLink>',
    product: 'Продукт',
    statement: 'Заявление',
    stepAgreement: {
      answerSomeQuestions: 'Ответьте на несколько вопросов и узнайте, что будет дальше',
      applyStatement:
        'Теперь, когда страховой случай зарегистрирован, вы можете подать заявление на получение страховой выплаты.',
      startProcedure: 'Это необходимо для запуска процедуры рассмотрения и принятия решения о выплате.',
      title: 'Подача заявления на заключение предпенсионного аннуитета и осуществление страховой выплаты',
    },
    stepWrapper: {
      application: 'Заявление на заключение предпенсионного аннуитета и осуществление страховой выплаты',
      confirm: 'Подтверждение',
      fillBasicInformation: 'Заполните основную информацию ',
      policyholder: 'Данные страхователя',
      victim: 'Сведения о потерпевшем',
    },
    terminations: {
      applicationHasBeenRejected: 'Ваше заявление отклонено',
      applicationHasBeenRejectedDescription: 'Документы не соотвествуют требованиям, необходимо заменить документ(-ы)',
      applicationOfTermination: 'Заявление о расторжении',
      applicationsForTermination: 'Заявления на расторжение',
      button: 'Продолжить',
      cancel_contract: 'Отказ от договора страхования',
      documentHelperTextTypes: {
        BANK_ACCOUNT_AVAILABILITY: 'Скачайте справку в мобильном приложении Банка',
        EARLY_LOAN_REPAYMENT:
          'Для получения справки обратитесь в филиал Банка или скачайте справку в мобильном приложении Банка',
        IDENTITY_CARD: 'Сканированный/Сфотографированный документ вашего удостоверения личности',
        INVALID_LOAN_AGREEMENT_RECOGNITION: 'Для получения справки обратитесь в филиал Банка',
      },
      documentsList: 'Список документов',
      faqs: {
        description: {
          step1:
            'Договора ненакопительного страхования жизни заемщика можно расторгнуть <highlightedText>при полном досрочном погашение займа</highlightedText> до окончания срока действия страховой защиты. Клиент может получить возврат страховой премии за вычетом части страховой премии пропорционально времени, в течение которого действовал договор страхования, и с удержанием <highlightedText>10%</highlightedText>.',
          step2:
            'Справку о задолженности можно получить у менеджера банка в филиале либо через мобильное приложение <highlightedText>Банк Центр Кредит</highlightedText>. На главной странице выберите раздел <highlightedText>"Другие сервисы"</highlightedText>, затем <highlightedText>"Получить справку"</highlightedText>, и далее выберите <highlightedText>"Справка об отсутствии задолженности"</highlightedText>. Справка должна содержать QR-подпись.',
          step3:
            'Справку о наличии счета можно получить в отделении банка либо в мобильном приложении Вашего банка (Kaspi, Halyk, BCC). Нажмите на дополнительную информацию по карточке, и Вы сможете найти раздел <highlightedText>«Справки о наличии счета»</highlightedText>.',
          step4:
            'Возврат страховой премии осуществляется за вычетом части страховой премии пропорционально времени, в течение которого действовал договор страхования, с удержанием 10% на возмещение административных расходов.',
        },
        highlighted: {
          step1: 'Отказ от договора займа в течение 14 дней с даты заключения договора страхования.',
          step2: 'Отказ от договора страхования в течение 14 дней с даты заключения.',
          step3: 'Отказ от договора страхования после 14 дней с даты заключения.',
          step4: 'Досрочное погашение займа.',
        },
        points: {
          stepFour1: 'Необходимо отметить соответствующий пункт в заявлении;',
          stepFour2: 'Требуется справка с Банка о досрочном погашении займа.',
          stepOne1: 'Необходимо отметить соответствующий пункт в заявлении.',
          stepOne2: 'Требуется справка из банка о досрочном погашении займа.',
          stepThree: 'Необходимо отметить соответствующий пункт в заявлении.',
          stepTwo: 'Необходимо отметить соответствующий пункт в заявлении.',
        },
        questions: {
          step1: 'Как сделать расторжение договора страхования?',
          step2: 'Как получить справку о задолженности?',
          step3: 'Как получить справку о наличии счета?',
          step4: 'Как рассчитывается сумма выплаты?',
        },
        titleText: {
          step1: ' Клиент может расторгнуть договор страхования с возвратом страховой премии полностью.',
          step2:
            ' Клиент может расторгнуть договор страхования по причине, не связанной с отказом от договора займа, с возвратом страховой премии за вычетом части страховой премии пропорционально времени, в течение которого действовал договор страхования и с удержанием 10%.',
          step3:
            ' Клиент может расторгнуть договор страхования по причине, не связанной с отказом от договора займа, без возврата страховой премии.',
          step4:
            ' Клиент может расторгнуть договор страхования по причине досрочного погашения займа с возвратом страховой премии за вычетом части страховой премии пропорционально времени, в течение которого действовал договор страхования и с удержанием 10%.',
        },
      },
      lastUpdateTerminationDate: 'Дата последнего обновления',
      notificationsNumber: 'Номер уведомления',
      pepRelatedHelperText:
        'Публичное должностное лицо – лицо, занимающее ответственную государственную должность; должностное лицо; лицо, уполномоченное на выполнение государственных функций; лицо, исполняющее управленческие функции в государственной организации или субъекте квазигосударственного сектора; лицо, назначаемое или избираемое, занимающее какую-либо должность в законодательном, исполнительном, административном, судебном органах или вооруженных силах иностранного государства; лицо, выполняющее какую-либо публичную функцию для иностранного государства; лицо, занимающее руководящую должность в организациях, созданных странами на основе соглашений, которые имеют статус международных договоров',
      pepRelatedLabelText:
        'Принадлежите и/или причастны ли вы к публичному должностному лицу, его супруге (супругу) и близким родственникам?',
      reason: 'Причина расторжения',
      sentToTerminationAt: 'Дата поступления заявки',
      settings: {
        step1: 'Скачайте бланк заявления на расторжение. ',
        step2: 'Заполните заявление в соответствии с предоставленной формой.',
        step3:
          'Распечатайте, подпишите и отправьте его по адресу: Республика Казахстан, г. Алматы, проспект Достык, д. 188 в течение 14 дней с момента заключения Договора займа',
      },
      terminationHasAlreadyCreated: 'Расторжение уже создано',
      terminationHasAlreadyCreatedMessage:
        'По данному договору уже инициирован процесс расторжения. Для просмотра деталей перейдите в раздел <strong>"Расторжения"</strong> в верхнем меню.',
      terminations: 'Расторжение',
      terminationType: 'Тип расторжения',
      updatedTerminationAt: 'Дата обновления заявки',
    },
  },
};
